// src/components/ContactSection.js
import { useTranslation } from "react-i18next";
import "./ContactInfoStyle.css";

const Contact = () => {
  const { t, i18n } = useTranslation();

  const formatInquiryText = (text) => {
    if (i18n.language !== "en") return text;

    const words = text.split(" ");
    return words.map((word, index) => (
      <span key={index}>
        {index < 2 ? (
          <>
            <span className="pinyon-first-letter">{word[0]}</span>
            {word.slice(1)}
          </>
        ) : (
          word
        )}
        {index < words.length - 1 && " "}
      </span>
    ));
  };

  return (
    <section className="contact-section-Par">
      <div className="container">
        <div
          className="contact-content-Par"
          dir={i18n.language === "ar" ? "rtl" : "ltr"}
        >
          <span className="contact-text-Par">
            {formatInquiryText(t("contactPar.inquiry"))}
          </span>
          <span className="contact-number-Par">{t("contactPar.phone")}</span>
        </div>
      </div>
    </section>
  );
};

export default Contact;
